import { render, staticRenderFns } from "./artistList.vue?vue&type=template&id=c04c99dc&scoped=true&"
import script from "./artistList.vue?vue&type=script&lang=js&"
export * from "./artistList.vue?vue&type=script&lang=js&"
import style0 from "./artistList.vue?vue&type=style&index=0&id=c04c99dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c04c99dc",
  null
  
)

export default component.exports